import {formatDefaultCurrency} from "@/app/utils/Format";

export default function(number) {
    return new Handlebars.SafeString(formatDefaultCurrency(number));
}